import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onNotificationClick } from '../services/pushService';

// Chi tocca la notifica "Qualcuno è bloccato dalla tua auto" deve trovarsi davanti
// al tasto "Sto arrivando", cioè sulla Home. Prima l'app riapriva l'ultima schermata
// visitata: chi l'aveva lasciata su Impostazioni trovava Impostazioni, proprio nel
// momento in cui doveva rispondere di fretta.
//
// Sta DENTRO il Router (come BackButtonHandler) perché `useNavigate` esiste solo lì.
// L'ascolto vero avviene in pushService fin dall'avvio: se l'app era chiusa e la
// notifica l'ha fatta partire, quel tocco viene messo da parte e consegnato qui
// appena questo componente si iscrive.
const NotificationClickHandler = () => {
  const navigate = useNavigate();

  useEffect(() => onNotificationClick(() => navigate('/')), [navigate]);

  return null;
};

export default NotificationClickHandler;
